import {tv} from 'tailwind-variants'
import {type OmitStrict} from 'type-zoo'
import {
  type HgTableTitleTextCell,
  type HgTableBodyTextCell,
} from '~/design-system/hg/components/HgTable/types'
import StandardTable from '~/design-system/hg/modules/HgTable/_components/StandardTable'

type WYSIWYGTableBodyCell = OmitStrict<
  HgTableBodyTextCell,
  'rightIconType' | 'image' | 'leftIconType' | 'caption' | 'hintProps'
> & {type: 'text'}

type WYSIWYGTableTitleCell = OmitStrict<
  HgTableTitleTextCell,
  'rightIconType' | 'leftIconType' | 'hintProps'
> & {type: 'text'}

export type WYSIWYGTableTitleRow = [
  WYSIWYGTableTitleCell,
  WYSIWYGTableTitleCell,
  WYSIWYGTableTitleCell?,
  WYSIWYGTableTitleCell?,
]

export type WYSIWYGTableBodyRow = [
  WYSIWYGTableBodyCell,
  WYSIWYGTableBodyCell,
  WYSIWYGTableBodyCell?,
  WYSIWYGTableBodyCell?,
]

export type WYSIWYGTableProps = {
  columnTitles?: WYSIWYGTableTitleRow | null
  rows: WYSIWYGTableBodyRow[]
  asymmetrical?: boolean
  className?: string
}

const tableVariant = tv({
  base: 'col-span-full mt-s5',
  variants: {
    numberOfColumns: {
      2: 'md:col-span-8 md:col-start-3 lg:col-start-5',
      3: 'lg:col-span-12 lg:col-start-3',
      4: 'lg:col-span-12 lg:col-start-3',
    },
  },
})

export const HgWYSIWYGTable = ({
  columnTitles,
  rows,
  asymmetrical,
  className,
}: WYSIWYGTableProps) => {
  return (
    <div
      className={tableVariant({numberOfColumns: rows[0]?.length, class: className})}
    >
      <StandardTable
        columnTitles={columnTitles}
        sections={[{type: 'default', rows}]}
        asymmetrical={asymmetrical}
      />
    </div>
  )
}
